/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Regulation28BreachedDetailsViewModel } from './Regulation28BreachedDetailsViewModel';
import {
    Regulation28BreachedDetailsViewModelFromJSON,
    Regulation28BreachedDetailsViewModelFromJSONTyped,
    Regulation28BreachedDetailsViewModelToJSON,
} from './Regulation28BreachedDetailsViewModel';

/**
 * 
 * @export
 * @interface Regulation28ResponseViewModel
 */
export interface Regulation28ResponseViewModel {
    /**
     * 
     * @type {string}
     * @memberof Regulation28ResponseViewModel
     */
    periodType?: string;
    /**
     * 
     * @type {string}
     * @memberof Regulation28ResponseViewModel
     */
    reg28Status?: string;
    /**
     * 
     * @type {Regulation28BreachedDetailsViewModel}
     * @memberof Regulation28ResponseViewModel
     */
    breachedDetails?: Regulation28BreachedDetailsViewModel;
}

/**
 * Check if a given object implements the Regulation28ResponseViewModel interface.
 */
export function instanceOfRegulation28ResponseViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Regulation28ResponseViewModelFromJSON(json: any): Regulation28ResponseViewModel {
    return Regulation28ResponseViewModelFromJSONTyped(json, false);
}

export function Regulation28ResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Regulation28ResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'periodType': !exists(json, 'PeriodType') ? undefined : json['PeriodType'],
        'reg28Status': !exists(json, 'Reg28Status') ? undefined : json['Reg28Status'],
        'breachedDetails': !exists(json, 'BreachedDetails') ? undefined : Regulation28BreachedDetailsViewModelFromJSON(json['BreachedDetails']),
    };
}

export function Regulation28ResponseViewModelToJSON(value?: Regulation28ResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PeriodType': value.periodType,
        'Reg28Status': value.reg28Status,
        'BreachedDetails': Regulation28BreachedDetailsViewModelToJSON(value.breachedDetails),
    };
}

